import React from "react";
import { Form } from "react-bootstrap";
import ArrowIcon from "../../../icons/arrow.icon";
import styles from "./msp-accounts-table-header.module.scss";

export const MspAccountsTableHeader = ({ isAllSelected, isIndeterminate, onSelectAll, showCheckbox = false }) => {
  const getWidthClass = (width) => {
    const widthMap = {
      "w-[205px]": styles.columnWidth205,
      "w-40": styles.columnWidth160,
      "w-60": styles.columnWidth240,
      "w-[234px]": styles.columnWidth234,
      "w-[140px]": styles.columnWidth140,
      "w-[93px]": styles.columnWidth93,
      "w-[146px]": styles.columnWidth146,
      "w-[121px]": styles.columnWidth121,
      "w-[167px]": styles.columnWidth167,
      "w-24": styles.columnWidth96,
      "w-[88px]": styles.columnWidth88,
      "w-[213px]": styles.columnWidth213,
    };
    return widthMap[width] || "";
  };

  const isFullWidthColumn = (label) => {
    return label === "Members" || label === "Companies" || label === "Clients" || label === "Prospects";
  };

  const columns = [
    { label: "Company name", width: "w-[205px]", hasArrow: true },
    { label: "Location", width: "w-40" },
    { label: "Account Owner", width: "w-60" },
    { label: "Sales Rep", width: "w-[234px]" },
    { label: "Signed up", width: "w-40" },
    { label: "Last Seen", width: "w-40" },
    { label: "Current Subscription", width: "w-[140px]" },
    { label: "Trial Days", width: "w-[93px]" },
    { label: "Renewal Date", width: "w-[146px]" },
    { label: "Auto Renewal", width: "w-[121px]" },
    { label: "Oversubscribed", width: "w-[121px]" },
    { label: "Tags", width: "w-[167px]" },
    { label: "Status", width: "w-24" },
    { label: "Members", width: "w-[88px]" },
    { label: "Companies", width: "w-[88px]" },
    { label: "Clients", width: "w-[88px]" },
    { label: "Prospects", width: "w-[88px]" },
    { label: "Integrations", width: "w-[213px]" },
    { label: "Products", width: "w-24" },
    { label: "Services", width: "w-24" },
    { label: "Packages", width: "w-[88px]" },
  ];

  const headerClassName = showCheckbox 
    ? `${styles.header} ${styles.headerWithCheckbox}`
    : styles.header;

  return (
    <header className={headerClassName}>
      {showCheckbox && (
        <div className={`${styles.columnWidth40} ${styles.column} ${styles.checkboxColumn}`}>
          <div className={styles.columnContainer}>
            <div className={styles.columnInner}>
              <div className={styles.checkboxContainer}>
                <Form.Group className={styles.checkboxGroup}>
                  <Form.Check
                    type="checkbox"
                    checked={isAllSelected}
                    ref={(input) => {
                      if (input) input.indeterminate = isIndeterminate;
                    }}
                    onChange={(e) => onSelectAll(e.target.checked)}
                    className={styles.checkbox}
                  />
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
      )}
      {columns.map((column, index) => (
        <div
          key={index}
          className={`${getWidthClass(column.width)} ${styles.column} ${column.label === "Company name" ? styles.columnCenter : ""}`}
        >
          <div
            className={isFullWidthColumn(column.label) ? styles.columnContainerFull : styles.columnContainer}
          >
            <div
              className={isFullWidthColumn(column.label) ? styles.columnInnerFull : styles.columnInner}
            >
              <div
                className={isFullWidthColumn(column.label) ? styles.columnLabelFull : styles.columnLabel}
              >
                {column.label}
              </div>
            </div>

            {column.hasArrow && (
              <div className={styles.arrowContainer}>
                <ArrowIcon className={styles.arrow} fill="#616778" />
              </div>
            )}
          </div>
        </div>
      ))}
    </header>
  );
};